import styled from 'styled-components/native'
import Card from 'APP/Converse/Card'
import Typography from 'APP/Converse/Typography'

export const Wrapper = styled.View`
  margin-top: ${({ theme }) => theme.metrics.baseMargin}px;
  margin-bottom: ${({ theme }) => theme.metrics.baseMargin}px;
  margin-horizontal: ${({ theme }) => theme.metrics.baseMargin}px;
`

export const ActionContainer = styled(Card)<{ hasAskQuestion?: boolean }>`
  ${({ theme }) => theme.shadows.normal};
  background-color: ${({ theme }) => theme.colors.elementsBg};
  border-radius: 20px;
  align-items: center;
  padding-horizontal: ${({ theme }) => theme.metrics.baseMargin}px;
  padding-top: ${({ theme }) => theme.metrics.baseMargin}px;
  padding-bottom: ${({ theme }) => theme.metrics.baseMargin * 1.5}px;
  ${({ hasAskQuestion, theme }) => hasAskQuestion && `padding: ${theme.metrics.baseMargin * 2}px;`}
`

export const CareJourneyHeader = styled(Typography)`
  padding-horizontal: ${({ theme }) => theme.metrics.baseMargin * 0.5}px;
  margin-bottom: ${({ theme }) => theme.metrics.baseMargin * 0.5}px;
`

export const CardText = styled(Typography)`
  margin-vertical: ${({ theme }) => theme.metrics.baseMargin}px;
`
